export default "__VITE_ASSET__Drs6Qn9A__"